import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TextareaAutosizeP2 } from '../../styled/typography/typographyExtentions'
import colors from '../../../configuration/colors'
import { H5 } from '../../styled/typography/typography'
import { LexiconContext } from '../../../contexts/Lexicon'

const textareaStyle = {
  width: '100%',
  minHeight: '80px',
  padding: '18px',
  marginTop: '10px',
  resize: 'none',
  border: `1px solid ${colors.rock}`,
  borderRadius: '5px'
}

const Label = styled(H5).attrs({
  as: 'label'
})`
  display: block;
  margin-top: 20px;
`

export default class TextFieldsMentor extends Component {
  state = {
    mentorNote: null,
    studentNote: null
  }

  constructor (props) {
    super(props)
    this.onMentorBlurBound = this.onMentorBlur.bind(this)
    this.onMentorChangeBound = this.onMentorChange.bind(this)
    this.onStudentBlurBound = this.onStudentBlur.bind(this)
    this.onStudentChangeBound = this.onStudentChange.bind(this)
  }

  static contextType = LexiconContext

  render () {
    const { lexicon } = this.context
    return (
      <div style={{ textAlign: 'left' }}>
        <Label
          htmlFor='mentor-internal-note'
        >
          Internal Note for {lexicon.mentor}s
        </Label>
        <TextareaAutosizeP2
          id='mentor-internal-note'
          style={textareaStyle}
          onBlur={this.onMentorBlurBound}
          onChange={this.onMentorChangeBound}
          placeholder={`Only ${lexicon.mentor.toLowerCase()}s will see this note.`}
        />
        <Label
          htmlFor='mentor-student-feedback'
        >
          Feedback for Student
        </Label>
        <TextareaAutosizeP2
          id='mentor-student-feedback'
          style={textareaStyle}
          onBlur={this.onStudentBlurBound}
          onChange={this.onStudentChangeBound}
          placeholder='Provide feedback that will be shared with the student.'
        />
      </div>
    )
  }

  onMentorBlur () {
    this.props.onMentorTextChange(this.state.mentorNote, this.props.index)
  }

  onMentorChange (e) {
    this.setState({
      mentorNote: e.currentTarget.value
    })
  }

  onStudentBlur () {
    this.props.onStudentTextChange(this.state.studentNote, this.props.index)
  }

  onStudentChange (e) {
    this.setState({
      studentNote: e.currentTarget.value
    })
  }
}

TextFieldsMentor.propTypes = {
  dispatch: PropTypes.func,
  index: PropTypes.number,
  onMentorTextChange: PropTypes.func,
  onStudentTextChange: PropTypes.func
}
